import { P2GGrid } from '@parcel2go/core-ui';
import { AddressProps } from './address';
import { AddressLookup } from '~/lib/types/edge-api-types';
import AddressContactName from './contact-name';
import { AlgoliaSearchObjectAddress } from '~/lib/types/algolia-types';
import SupportingLabel from '~/components/supporting-label/supporting-label';
import AddressSearchCore from './search-core';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export type SearchAddressVariant = 'suggest' | 'button';

type AddressSearchProps = {
  onSelected: (address: AddressLookup) => void;
  onAutoComplete: (address: AlgoliaSearchObjectAddress) => void;
} & AddressProps;

export default function AddressSearch({
  section,
  requirements,
  type,
  onSelected,
  errors,
  onAutoComplete,
  forceSelection,
  disabledFields
}: AddressSearchProps) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  return (
    <P2GGrid container spacing={2} direction="column" dataTestId="address-search">
      <P2GGrid item>
        <AddressContactName
          requirements={requirements}
          address={section.data}
          onChange={(value) => section.update(value)}
          errors={errors}
          loading={section.loading}
          type={type}
          onAutoComplete={onAutoComplete}
          disabled={disabledFields.includes('contactname')}
          disableSearch={!!forceSelection}
        />
      </P2GGrid>
      <P2GGrid item>
        <AddressSearchCore errors={errors} onSelected={onSelected} section={section} type={type} optional={false} />
      </P2GGrid>
      <P2GGrid item>
        <SupportingLabel
          text={t('ADDRESS_SEARCH_HELPER_TEXT', {
            defaultValue: 'Start typing your house number, street and postcode.'
          })}
        />
      </P2GGrid>
    </P2GGrid>
  );
}
